// Declarations
export const FIELDS = "fields";

export const FIELDS_LISTING = "list";

export const FIELDS_MAPPING = "mapping";

export const DATA_STUDIO = "datastudio";

export const FORM_FIELD = "FORM_FIELD";

export const REVV_FIELD = "REVV_FIELD";

export const SOURCE_FIELD = "SOURCE_FIELD";

export const FIELDS_VIEWS = [
  {
    name: "Form Inspector",
    settingsView: FIELDS_LISTING,
    fullpath: "/fields/list",
    faStyle: "far",
    faIcon: "files-medical",
  },
  {
    name: "Data Studio",
    settingsView: FIELDS_MAPPING,
    fullpath: "/fields/datastudio",
    faStyle: "far",
    faIcon: "files-medical",
  },
];

export const FIELDS_DEFAULT_VIEW_URL = FIELDS_VIEWS[0].fullpath;
export const FIELDS_DATASTUDIO_VIEW_URL = FIELDS_VIEWS[1].fullpath;

export const FIELDS_LISTING_VIEW_COLUMNS = [
  {
    field: "label",
    name: "label",
    headerName: "Field Name",
    editable: false,
    hidden: undefined,
    hide: false,
    minWidth: 80,
    position: 1,
    props: { length: 200 },
    required: true,
    resizable: false,
    sortable: true,
    standard: true,
    suppressMenu: true,
    type: "text",
    visible: true,
    width: 100,
  },
  {
    editable: false,
    field: "type",
    headerName: "Field Value Type",
    hidden: undefined,
    hide: false,
    minWidth: 80,
    name: "type",
    position: 2,
    props: { length: 20 },
    required: true,
    resizable: false,
    sortable: true,
    standard: true,
    suppressMenu: true,
    type: "text",
    visible: true,
    width: 100,
  },
  {
    editable: false,
    field: "parent_field",
    headerName: "Field Type",
    hidden: undefined,
    hide: false,
    minWidth: 80,
    name: "parent_field",
    position: 3,
    props: { length: 20 },
    required: true,
    resizable: false,
    sortable: true,
    standard: true,
    suppressMenu: true,
    type: "text",
    visible: true,
    width: 100,
  },
  {
    field: "defaultValue",
    name: "defaultValue",
    headerName: "Default Value",
    editable: false,
    hidden: undefined,
    hide: false,
    minWidth: 80,
    position: 3,
    props: { length: 200 },
    required: true,
    resizable: false,
    sortable: false,
    standard: true,
    suppressMenu: true,
    type: "text",
    visible: true,
    width: 100,
  },
  {
    field: "crm_source",
    name: "crm_source",
    headerName: "Data Source",
    editable: false,
    hidden: undefined,
    hide: false,
    minWidth: 80,
    position: 4,
    props: { length: 200 },
    required: true,
    resizable: false,
    sortable: true,
    standard: true,
    suppressMenu: true,
    type: "text",
    visible: true,
    width: 100,
    // cellRenderer: "LinkComponent",
  },
];

export const DATA_SOURCES = [
  {
    name: "salesforce",
    label: "Salesforce",
    urlRef: "SF",
    sourceName: "sf",
  },
  {
    name: "hubspot",
    label: "Hubspot",
    urlRef: "HS",
    sourceName: "hs",
  },
  {
    name: "csv",
    label: "CSV",
    urlRef: "CSV",
    sourceName: "csv",
  },
];

// fields type to value division
export const FIELDS_SUB_DIVISION_MAP = {
  PERIOD: ["periodValue", "periodUom"],
  ADDRESS: [
    "addressLineOne",
    "addressLineTwo",
    "city",
    "state",
    "zip",
    "country",
  ],
  PERSON_NAME: ["firstName", "lastName"],
  RATE: ["rateValue", "rateUom"],
  SIGNATURE: ["firstName", "lastName", "email"],
};

export const TRANSFORMATION_LIST = [
  {
    active: true,
    field_type: "string",
    value: "trim",
    label: "Trim",
    input_required: false,
  },
  {
    active: true,
    field_type: "string",
    value: "mask",
    label: "Mask",
    input_required: true,
    input_list: [
      {
        input_type: "string",
        input_label: "Mask with ",
        input_name: "mask_with",
        input_placeholder: "Use ( *,# )",
      },
    ],
  },
  {
    active: false,
    field_type: "string",
    value: "truncate",
    label: "Truncate",
    input_required: true,
    input_list: [
      {
        input_type: "int",
        input_label: "Truncate after ",
        input_name: "after",
        input_placeholder: "Use ( ,-/ )",
      },
    ],
  },
  {
    active: false,
    field_type: "string",
    value: "split",
    label: "Split",
    input_required: true,
    input_list: [
      {
        input_type: "string",
        input_label: "Split with ",
        input_name: "split_with",
        input_placeholder: "Use ( ,-/# )",
      },
      {
        input_type: "int",
        input_label: "Pick index ",
        input_name: "index",
      },
    ],
  },
  {
    active: false,
    field_type: "string",
    value: "prefix",
    label: "Prefix",
    input_required: true,
    input_list: [
      {
        input_type: "string",
        input_label: "Add Prefix ",
        input_name: "prefix",
        input_placeholder: "Add Revv-",
      },
    ],
  },
  {
    active: false,
    field_type: "string",
    value: "postfix",
    label: "Postfix",
    input_required: true,
    input_list: [
      {
        input_type: "string",
        input_label: "Add Postfix ",
        input_name: "postfix",
        input_placeholder: "Add -Revv",
      },
    ],
  },
];

export const DATA_STUDIO_VIEW = {
  CONFIG_VIEW: "CONFIG_VIEW",
  MAPPED_VIEW: "MAPPED_VIEW",
};
